/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'zoom-plus': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" d="M12 0v10h10v2H12v10h-2V12H0v-2h10V0h2z" _fill="#000" fill-rule="evenodd"/>'
  }
})
